import { useRef, useState, useEffect } from "react";
import { Icon } from "@iconify/react";

export default function Pricing({
  name,
  description,
  yearly_price,
  period,
  all_benefits,
  is_popular,
  openPopUp,
  item,
  duration,
}) {
  const headRef = useRef(null);
  const bottomRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (headRef.current && bottomRef.current) {
        const headRect = headRef.current.getBoundingClientRect();
        const bottomRect = bottomRef.current.getBoundingClientRect();
        setIsOverflowing(bottomRect.bottom > headRect.bottom);
      }
    };

    checkOverflow();
    const observer = new ResizeObserver(checkOverflow);
    if (headRef.current) observer.observe(headRef.current);
    if (bottomRef.current) observer.observe(bottomRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    // <div className="cs_pricing_card cs_style_1 cs_radius_20 overflow-hidden">
    //   <div className="cs_pricing_card_head cs_accent_bg cs_white_color" style={{ backgroundColor: '#0e6ebe' }}>
    //     <h3 className="cs_white_color cs_fs_18 cs_semibold">
    //       <span className="cs_accent_bg">{name}</span>
    //       {is_popular == 1 && (
    //         <span className="cs_heading_color cs_normal">Popular</span>
    //       )}
    //     </h3>
    //     {/* {description && <p className="cs_fs_10">{description}</p>} */}
    //     <h2 className="cs_white_color mb-0 cs_fs_24 cs_semibold" style={{ color: '#fff' }}>
    //       ₹ {Math.trunc(Number(yearly_price))}
    //       <span className="cs_fs_18">
    //         /{duration == 30 ? 'month' : 'year'}
    //       </span>
    //     </h2>
    //     <button className={`cs_btn cs_style_1`} onClick={() => openPopUp(item)}>
    //       <span style={{ fontWeight: "bold" }}>Choose Plan</span>
    //       {/* <i>
    //         <img src="images/icons/arrow_white.svg" alt="Icon" />
    //         <img src="images/icons/arrow_white.svg" alt="Icon" />
    //       </i> */}
    //     </button>
    //   </div>

    <div className="cs_pricing_card cs_style_1 cs_radius_20 overflow-hidden">
      <div
        ref={headRef}
        className="cs_pricing_card_head cs_accent_bg cs_white_color"
        style={{ backgroundColor: "#0e6ebe" }}
      >
        <div className="cs_pricing_card_top">
          <h3 className="cs_white_color cs_fs_18 cs_semibold">
            <span
              className="cs_accent_bg"
              style={{
                minWidth: "160px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {name}
            </span>
            {is_popular == 1 && (
              <span className="cs_heading_color cs_normal">Popular</span>
            )}
          </h3>
        </div>

        <div
          ref={bottomRef}
          className="cs_pricing_card_bottom"
          style={{
            marginTop: "20px",
            ...(isOverflowing
              ? { display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }
              : {}),
          }}
        >
          <h2 className="cs_white_color mb-0 cs_fs_24 cs_semibold">
            <span style={{ fontSize: "24px" }}>
              ₹
            </span>
            {Math.trunc(Number(yearly_price))}
            <span className="cs_fs_18">
              /year
            </span>
          </h2>
          <button className="cs_btn cs_style_1" onClick={() => openPopUp(item)}>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>Choose Plan</span>
          </button>
        </div>
      </div>
      <div className="cs_pricing_card_body">
        <ul className="cs_pricing_card_feature cs_fs_15 cs_heading_color">
          {all_benefits?.map((item, index) => (
            <li key={index}>
              <i>
                <Icon icon="fa6-solid:circle-check" />
              </i>
              {item}
            </li>
          ))}
        </ul>
        {/* <div className="cs_pricing_card_btn text-center">
          <button className={`cs_btn cs_style_1`} onClick={() => openPopUp(item)}>
            <span>Choose Plan</span>
            <i>
              <img src="images/icons/arrow_white.svg" alt="Icon" />
              <img src="images/icons/arrow_white.svg" alt="Icon" />
            </i>
          </button>
        </div> */}
      </div>
    </div>
  );
}
